<template>
  <div class="pos-container">
    <PosHeader :isLogin="true" />

    <div class="cash-given-container">
    <PosCashCalculator nextRoute="pos-booking" />
      <!-- <nav>
        <router-link to="#" class="btn-outline-blue-lg bg-transparent text-blue mr-2">Back</router-link>
        <router-link to="pos-booking" class="btn-blue-lg ml-2">Next</router-link>
      </nav>-->
    </div>
  </div>
</template>



<script>
import PosHeader from "@/components/Partials/posHeader.vue";
import PosCashCalculator from "@/components/Partials/posCashCalculator";
export default {
  components: {
    PosHeader,
    PosCashCalculator
  }
};
</script>

<style>
.pos-cash-calculator {
  margin-bottom: 100px;
}
</style>

 


// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posCashInput.vue